'use strict';

module.exports = require('react').addons;



//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react/static-7.41/react-addons.js
// module id = 33
// module chunks = 0